<template>
	<header class="headWrapper noprint" ref="headWrapper" v-loading.fullscreen.lock="loading"
		element-loading-text="图片上传中，请稍后...">
		<section class="lineTop noprint">
			<section class="lineTopLeft">
				<span>欢迎来到淘辅网CNFZFLW</span>
				<a v-if="!userInfo || !userInfo.username" @click.prevent="toLogin">请登录</a>
				<a v-if="!userInfo || !userInfo.username" @click.prevent="toRegist">免费注册</a>
				<a v-if="userInfo && userInfo.username" class="username" @click.prevent="toUsercenter">{{ userInfo.username
				}}</a>
				<a v-if="userInfo && userInfo.username" class="logout" @click.prevent="logout">退出登录</a>
			</section>
			<section class="lineTopRight">
				<a href="https://iscm.cnfzflw.com/#/login" target="_blank" rel="noopener noreferrer">前往云数智赋供应链平台</a>
				<a @click.prevent="toUsercenter">个人中心</a>
				<span>客服热线：</span><span class="tel">0571-56398600</span>
			</section>
		</section>
		<section class="lineMiddle noprint" v-if="!usercenter">
			<section class="logo">
				<img class="logoImg" src="@/assets/images/logo_new.png" alt="logo" @click="toHome">
			</section>
			<section class="search">
				<el-tabs class="tab" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="供应" name="1"></el-tab-pane>
					<el-tab-pane label="求购" name="2"></el-tab-pane>
					<el-tab-pane label="资讯" name="3"></el-tab-pane>
					<el-tab-pane label="展会" name="4"></el-tab-pane>
					<el-tab-pane label="企业" name="5"></el-tab-pane>
					<el-tab-pane label="设计师" name="6"></el-tab-pane>
				</el-tabs>
				<div class="search_icon">
					<img src="@/assets/images/search_icon1.png" width="13" height="13">
				</div>
				<div class="camera_icon">
					<el-upload :action="imgUploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img src="@/assets/images/camera.png">
					</el-upload>
				</div>
				<el-input class="searchInput" placeholder="请输入关键字" v-model="keyWOrds" size="small"
					@keyup.enter.native="searchClick">
					<el-button class="searchBtn" slot="append" @click="searchClick">搜索</el-button>
				</el-input>
				<div class="typeBtn">
					<div class="typeBtnItem" v-for="item in typeBtnList" :key="item.id" @click="typeBtnClick(item)">
						{{ item.title }}</div>
				</div>
			</section>
		</section>
		<!-- 非个人中心页面 -->
		<nav class="nav noprint" v-show="!usercenter">
			<el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
				background-color="rgba(255,157,7,1)" text-color="#fff" active-text-color="#fff">
				<el-menu-item index="1">首页</el-menu-item>
				<el-submenu index="2">
					<template slot="title">辅料</template>
					<el-menu-item index="2-1">辅料产品供应</el-menu-item>
					<el-menu-item index="2-2">辅料产品求购</el-menu-item>
				</el-submenu>
				<el-submenu index="3">
					<template slot="title">企业</template>
					<el-menu-item index="3-1">辅料供应商</el-menu-item>
					<el-menu-item index="3-2">辅料采购商</el-menu-item>
				</el-submenu>
				<el-submenu index="4">
					<template slot="title">行业信息</template>
					<el-menu-item index="4-1">行业资讯</el-menu-item>
					<el-menu-item index="4-2">展会信息</el-menu-item>
				</el-submenu>
				<el-menu-item index="5">设计师</el-menu-item>
				<el-submenu index="6">
					<template slot="title">智能科技服务</template>
					<el-menu-item index="6-1">智能科技服务</el-menu-item>
				</el-submenu>
				<el-menu-item index="7">图搜搜</el-menu-item>
			</el-menu>
		</nav>
		<!-- 个人中心页面 -->
		<nav class="usercenterNav noprint" v-show="usercenter">
			<section class="logo usercenter-logo">
				<img class="logoImg" src="@/assets/images/logo_new_login.png" alt="logo" @click="toHome">
			</section>
			<el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelectUsercenter"
				background-color="rgba(255,157,7,1)" text-color="#fff" active-text-color="#fff">
				<el-menu-item index="1">首页</el-menu-item>
				<!-- 产品管理 白号/个人采购商/个人设计师不显示 子账号中的企业管理员1和业务员3显示部分 -->
				<!-- <el-submenu index="2" v-if="userInfo.vip_type != 0 && userInfo.vip_type != 3 && userInfo.vip_type != 4"> -->
				<el-submenu index="2"
					v-if="userInfo.vip_type == 1 || userInfo.vip_type == 2 || userInfo.vip_type == 5 || (userInfo.member_type >= 1 && userInfo.member_type <= 4)">
					<template slot="title">产品管理</template>
					<!-- 供应商 产品编号设置 -->
					<el-menu-item index="2-5" v-if="userInfo.vip_type == 1">设置产品编码前缀</el-menu-item>
					<!-- 已发布供应信息 企业采购商/设计公司不显示 -->
					<el-menu-item index="2-1"
						v-if="userInfo.vip_type == 1 || (userInfo.member_type >= 1 && userInfo.member_type <= 4)">已发布供应信息</el-menu-item>
					<!-- 联盟供应信息 is_union联盟成员显示 -->
					<el-menu-item index="2-6" v-if="userInfo.vip_type == 1 && userInfo.is_union == 1">联盟供应信息</el-menu-item>
					<!-- 发布供应信息 企业采购商/设计公司不显示 -->
					<el-menu-item index="2-2"
						v-if="userInfo.vip_type == 1 || (userInfo.member_type >= 1 && userInfo.member_type <= 4)">发布供应信息</el-menu-item>
					<!-- 发布供应信息 企业采购商/设计公司不显示 -->
					<el-menu-item index="2-7" v-if="userInfo.vip_type == 1 || userInfo.member_type == 3">模板管理</el-menu-item>
					<!-- 已发布采购信息 供应商不显示 -->
					<el-menu-item index="2-3" v-if="userInfo.vip_type == 2 || userInfo.vip_type == 5">已发布采购信息</el-menu-item>
					<!-- 发布采购信息 供应商不显示 -->
					<el-menu-item index="2-4" v-if="userInfo.vip_type == 2 || userInfo.vip_type == 5">发布采购信息</el-menu-item>
					<!-- 开通了独立企业小程序的显示 -->
					<el-menu-item index="2-8" v-if="userInfo.is_duli == 1">自定义分类列表</el-menu-item>
				</el-submenu>
				<!-- 生产管理  白号不显示  v-if="userInfo.vip_type == 1" -->
				<el-submenu v-if="userInfo.is_tracking == 1" index="12">
					<template slot="title">生产管理</template>
					<el-menu-item index="12-1"
						v-if="userInfo.vip_type == 1 || userInfo.member_type == 1 || userInfo.member_type == 3">客户管理</el-menu-item>
					<el-menu-item index="12-2" v-if="userInfo.member_type != 6">订单管理</el-menu-item>
					<!-- <el-menu-item index="12-4">购买订单管理</el-menu-item> -->
					<!-- <el-menu-item index="12-3" v-if='userInfo.member_type == 1 || userInfo.member_type == 3'>新建订单</el-menu-item> -->
					<!-- <el-menu-item index="12-5" v-if='userInfo.member_type == 1 || userInfo.member_type == 3'>预设产品</el-menu-item> -->
					<el-menu-item index="12-6"
						v-if='userInfo.vip_type == 1 || userInfo.member_type >= 1 && userInfo.member_type <= 3'>预设产品列表</el-menu-item>
					<el-menu-item index="12-7"
						v-if='!userInfo.member_type || userInfo.member_type == 1 || userInfo.member_type == 3'>出货单管理</el-menu-item>
					<!-- <el-menu-item index="12-8" v-if="userInfo.vip_type == 1 || userInfo.member_type == 1 || userInfo.member_type == 3">生产产品类型列表</el-menu-item> -->
					<!-- <el-menu-item index="12-9" v-if="userInfo.member_type == 2 || userInfo.member_type == 3">发货列表</el-menu-item> -->
					<!-- <el-menu-item index="12-10" v-if='userInfo.member_type == 1 || userInfo.member_type == 3'>已生成出货单的列表</el-menu-item> -->
					<el-menu-item index="12-11"
						v-if='userInfo.vip_type == 1 || userInfo.member_type == 1 || userInfo.member_type == 6'>核销管理</el-menu-item>
					<!-- <el-menu-item index="12-12" v-if='userInfo.member_type == 6'>核销记录</el-menu-item>
			    <el-menu-item index="12-13" v-if='userInfo.member_type == 6'>导出清单</el-menu-item> -->
				</el-submenu>
				<!-- 订单管理 白号不显示 -->
				<el-submenu index="3" v-if="userInfo.vip_type != 0 || userInfo.member_type == 3">
					<template slot="title">订单管理</template>
					<el-menu-item index="3-1">商品订单</el-menu-item>
					<el-menu-item index="3-2" v-if="!userInfo.member_type">会员订单</el-menu-item>
					<!-- <el-menu-item index="3-4" v-if="userInfo.vip_type == 1 && userInfo.is_union == 1">联盟订单</el-menu-item> -->
					<el-menu-item index="3-3" v-if="userInfo.vip_type == 1 && userInfo.is_duli == 1">邀请码订单</el-menu-item>
				</el-submenu>
				<!-- 发票管理  白号不显示 -->
				<!-- <el-submenu index="11" v-if="userInfo.vip_type != 0">
			    <template slot="title">发票管理</template>
			    <el-menu-item index="11-1">我的发票</el-menu-item>
			  </el-submenu> -->
				<!-- T币管理  全都显示  子账号不显示 -->
				<el-submenu v-if="!userInfo.member_type" index="4">
					<template slot="title">T币管理</template>
					<el-menu-item index="4-1">T币管理</el-menu-item>
					<el-menu-item index="4-2">T币列表</el-menu-item>
				</el-submenu>
				<!-- 信息管理 全都显示 子账号中的业务员显示 -->
				<el-submenu v-if="!userInfo.member_type || userInfo.member_type == 3" index="5">
					<template slot="title">信息管理</template>
					<!-- 我发布的报价 白号/供应商显示 -->
					<el-menu-item index="5-1"
						v-if="userInfo.vip_type == 0 || userInfo.vip_type == 1 || userInfo.member_type == 3">我发布的报价</el-menu-item>
					<!-- 我收到的报价 企业采购商/设计公司显示 -->
					<el-menu-item index="5-2" v-if="userInfo.vip_type == 2 || userInfo.vip_type == 5">我收到的报价</el-menu-item>
					<!-- 我发布的询价 全部显示 -->
					<el-menu-item index="5-3">我发布的询价</el-menu-item>
					<!-- 我收到的询价 供应商显示 -->
					<el-menu-item index="5-4"
						v-if="userInfo.vip_type == 1 || userInfo.member_type == 3">我收到的询价</el-menu-item>
				</el-submenu>
				<!-- 我的收藏  全都显示 -->
				<el-menu-item index="6">我的收藏</el-menu-item>
				<!-- 购物车  白号和供应商不显示 -->
				<el-menu-item index="7" v-if="userInfo.vip_type != 0 && userInfo.vip_type != 1">购物车</el-menu-item>
				<!-- 设计师 个人设计师显示 -->
				<el-submenu index="9" v-if="userInfo.vip_type == 4 || userInfo.vip_type == 5">
					<template slot="title">设计师</template>
					<!-- <el-menu-item index="9-1">设计师信息</el-menu-item> -->
					<el-menu-item index="9-2">发布作品</el-menu-item>
					<el-menu-item index="9-3">我的作品</el-menu-item>
				</el-submenu>
				<!-- 增值服务  只有供应商显示 -->
				<el-submenu index="10" v-if="userInfo.vip_type == 1">
					<template slot="title">增值服务</template>
					<el-menu-item index="10-1">定制版小程序</el-menu-item>
					<el-menu-item index="10-2">一物一码列表</el-menu-item>
					<el-menu-item index="10-3" v-if="userInfo.is_union == 1">联盟信息管理</el-menu-item>
				</el-submenu>
				<!-- 个人中心  全都显示 -->
				<el-submenu index="8">
					<template slot="title">个人中心</template>
					<el-menu-item v-if="!userInfo.member_type" index="8-1">会员服务</el-menu-item>
					<!-- 企业信息 白号/设计师/设计公司不显示 -->
					<el-menu-item index="8-2"
						v-if="userInfo.vip_type == 1 || userInfo.vip_type == 2 || userInfo.vip_type == 3">企业信息管理</el-menu-item>
					<!-- 设计师信息 设计师/设计公司显示 -->
					<el-menu-item index="8-5" v-if="userInfo.vip_type == 4 || userInfo.vip_type == 5">设计师信息</el-menu-item>
					<el-menu-item index="8-3">账号信息管理</el-menu-item>
					<el-menu-item v-if="!userInfo.member_type" index="8-4">收货地址管理</el-menu-item>
				</el-submenu>
			</el-menu>
		</nav>
		<!-- 弹框搜索跳转页面 -->
		<el-dialog title="提示" :visible.sync="dialogVisible" :close-on-click-modal="false" width="350px">
			<div
				style="width: 350px; margin: -25px 0 0 -20px; padding-top: 20px; text-align: center; border-top: 1px solid #e9e9e9;">
				<img src="@/assets/images/search_tips.png">
				<br>
				<el-button style="background: #ff9600; color: #fff; width: 100px; margin-top: 30px; border-radius: 4px;"
					@click="toNewPage">搜 索</el-button>
			</div>
		</el-dialog>
	</header>
</template>

<script>
import ImgCutter from '@/components/ImgCutter.vue'
import { getToken, setToken } from '@/utils/auth' // 验权
import { supply_search, buy_search } from '@/api/userCenter/productManage'
import { imgSearchUrl, image_path, bin_path } from '@/config/env.js'
import { get_userinfo } from '@/api/public'
import { designer_work_search } from '@/api/userCenter/personal'
import { verify_token } from '@/api/userCenter/home'

export default {
	name: 'pageHead',
	data() {
		return {
			userInfo: {}, 		// 用户信息
			usercenter: false,			// 是否是个人中心页面
			activeName: '1',
			activeIndex: '1',
			keyType: '1',
			keyWOrds: '',
			// typeList: [
			// 	{value: '1', label: '供应'},
			// 	{value: '2', label: '求购'},
			// 	{value: '3', label: '资讯'},
			// 	{value: '4', label: '展会'},
			// 	{value: '5', label: '企业'},
			// ],
			typeBtnList: [
				{ id: '1', title: '纽扣' },
				{ id: '2', title: '金属拉链' },
				{ id: '3', title: '织带' },
				{ id: '4', title: '衣架' },
				{ id: '5', title: '衬衫' },
				{ id: '6', title: '商标' },
			],
			imgUploadUrl: '',				// 上传图片的路径
			loading: false,
			bin: '',
			newUrl: '',
			dialogVisible: false,
		}
	},
	components: {
		ImgCutter
	},
	created() {
		this.imgUploadUrl = imgSearchUrl
		this.bin = bin_path
		let bin = `["${this.bin}"]`
		this.$nextTick(() => {
			this.isLogin(getToken())
			this.isUsercenter(this.$route.name.substr(0, 3))
		})
		// console.log(this.$route.query.keyword);
		this.keyWOrds = this.$route.query.keyword
	},
	//已加载页面触发
	activated() {
		this.getInfoUploadToken()
	},
	methods: {
		// 判断是否是个人中心的页面
		isUsercenter(val) {
			if (val === 'log') {
				this.usercenter = true
				this.$refs.headWrapper.className = 'headWrapper-userCenter'
			} else {
				this.usercenter = false
				this.$refs.headWrapper.className = 'headWrapper'
			}
		},
		// 判断是否已经登录
		isLogin(userInfo) {
			if (userInfo && userInfo != undefined && userInfo != 'null') {
				this.userInfo = JSON.parse(userInfo)
				// 获取最新的用户信息并更新token
				this.getInfoUploadToken()
			} else {
				this.userInfo = {}
			}
		},
		// 获取最新的用户信息并更新token
		getInfoUploadToken() {
			if (this.$route.name == 'loghome' && this.$route.query && this.$route.query.token) {
				verify_token({ token: this.$route.query.token }).then(res => {
					if (res.code == 200) {
						this.userInfo = res.userinfo
						setToken(res.userinfo)
					}
				})
			} else if (this.userInfo.id) {
				get_userinfo({ userid: this.userInfo.id }).then(res => {
					if (res.code == 200) {
						this.userInfo = res.userinfo
						setToken(res.userinfo)
					}
				})
			} else {
				this.userInfo = {}
			}
		},
		// 非个人中心页面的导航改变
		handleSelect(key, keyPath) {
			this.handleSelectDetail(key, keyPath, 1)
		},
		// 个人中心页面的导航改变
		handleSelectUsercenter(key, keyPath) {
			this.handleSelectDetail(key, keyPath, 2)
		},
		// 页面的导航改变 type: 1-非个人中心页面  2-个人中心页面
		handleSelectDetail(key, keyPath, type) {
			let pathname = 'home'
			if (type === 1) {
				if (key === '2-1') {
					pathname = 'productSupply'
				} else if (key === '2-2') {
					pathname = 'productPurchase'
				} else if (key === '3-1') {
					pathname = 'supplier'
				} else if (key === '3-2') {
					pathname = 'purchaser'
				} else if (key === '4-1') {
					pathname = 'industryInfo'
				} else if (key === '4-2') {
					pathname = 'exhibitionInfo'
				} else if (key === '5') {
					pathname = 'designerIndex'
				} else if (key === '6-1') {
					window.open("http://tpzn.cnfzflw.com", "_blank")
					return
				} else if (key === '7') {
					pathname = 'imgSearchIndex'
				}
			} else if (type === 2) {
				pathname = 'loghome'
				if (key === '2-1') {
					pathname = 'logsupplyList'
				} else if (key === '2-2') {
					// pathname = 'logsupplyAdd'
					this.isAdd(1)
					return
				} else if (key === '2-3') {
					pathname = 'logsupplyList'
				} else if (key === '2-4') {
					// pathname = 'logsupplyAdd'
					this.isAdd(2)
					return
				} else if (key === '2-5') {
					let isGo = this.isOperate()
					if (!isGo) return
					pathname = 'logsupplyPrefix'
				} else if (key === '2-6') {
					pathname = 'logunionSupplyList'
				} else if (key === '2-7') {
					pathname = 'logsupplyTemplate'
				} else if (key === '2-8') {
					pathname = 'logsupplyDiy'
				} else if (key === '3-1') {
					if (this.userInfo.vip_type == 1) {
						pathname = 'logorderManageSell'
					} else {
						pathname = 'logorderManage'
					}
				} else if (key === '3-2') {
					pathname = 'logorderVip'
				} else if (key === '3-3') {
					pathname = 'logorderIndependent'
				} else if (key === '3-4') {
					pathname = 'logorderUnion'
				} else if (key === '4-1') {
					pathname = 'logtbManage'
				} else if (key === '4-2') {
					pathname = 'logtbList'
				} else if (key === '5-1') {
					const url = this.$router.resolve({ name: 'loginfoManage', query: { type: 1 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '5-2') {
					const url = this.$router.resolve({ name: 'loginfoManage', query: { type: 2 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '5-3') {
					const url = this.$router.resolve({ name: 'loginfoManage', query: { type: 3 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '5-4') {
					const url = this.$router.resolve({ name: 'loginfoManage', query: { type: 4 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '6') {
					pathname = 'logmyStar'
				} else if (key === '7') {
					pathname = 'logcar'
				} else if (key === '8-1') {
					if (this.userInfo.vip_type == 0 || this.userInfo.is_company == 1) {
						pathname = 'logvipSelect'
					} else if (this.userInfo.vip_type > 0) {
						pathname = 'logvipServices'
					}
				} else if (key === '8-2') {
					const url = this.$router.resolve({ name: 'logcompanyInfo', query: { edit_type: 2 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '8-3') {
					pathname = 'loguserInfo'
				} else if (key === '8-4') {
					pathname = 'logaddress'
				} else if (key === '8-5') {
					const url = this.$router.resolve({ name: 'logcompanyInfo', query: { edit_type: 2 } })
					window.open(url.href, "_blank")
					return
				} else if (key === '9-2') {
					let isGo = this.isOperate()
					if (!isGo) return
					pathname = 'logdesignerManage'
					this.isAddDesigner()
					return
				} else if (key === '9-3') {
					pathname = 'logdesignerProduct'
				} else if (key === '10-1') {
					if (this.userInfo.is_duli == 1) {
						pathname = 'logindependentSet'
					} else {
						pathname = 'logindependentSystem'
					}
				} else if (key === '10-2') {
					pathname = 'logwechatCode'
				} else if (key === '10-3') {
					if (this.userInfo.is_union == 0) pathname = 'logunionSystem'
					if (this.userInfo.is_union == 1) pathname = 'logunionSet'
				} else if (key === '11-1') {
					pathname = 'logmyInvoice'
				} else if (key === '12-1') {
					pathname = 'logcustomerManagement'
					this.$router.push({ name: pathname })
					return
				} else if (key === '12-2') {
					pathname = 'logorderManagement'
					if (this.userInfo.member_type == 2 || this.userInfo.member_type == 4 || this.userInfo.member_type == 5) {
						pathname = 'logproductManagement'
					}
					this.$router.push({ name: pathname })
					return
				} else if (key === '12-3') {
					pathname = 'logaddOrder'
				} else if (key === '12-4') {
					pathname = 'logorderManagementBuy'
				} else if (key === '12-5') {
					pathname = 'logpresetProduct'
				} else if (key === '12-6') {
					pathname = 'logpresetProductList'
					this.$router.push({ name: pathname })
					return
				} else if (key === '12-7') {
					pathname = 'logsalesOrder'
					this.$router.push({ name: pathname })
					return
				} else if (key === '12-8') {
					pathname = 'logcateList'
				} else if (key === '12-9') {
					pathname = 'logsalesList'
				} else if (key === '12-10') {
					pathname = 'logsalesDoneList'
				} else if (key === '12-11') {
					pathname = 'logwriteoffSalesList'
				} else if (key === '12-12') {
					pathname = 'logwriteoffRecord'
				} else if (key === '12-13') {
					pathname = 'logwriteoffOutList'
				}
				if (!this.userInfo || !this.userInfo.username) {
					this.$router.push({ name: 'login', params: { name: pathname } })
				}
			}
			// this.$router.push({name: pathname})
			if (pathname === 'home') {
				if (this.$route.name === 'home') return
				this.$router.push({ name: 'home' })
				return
			}
			// 新页面打开网页
			const url = this.$router.resolve({ name: pathname });
			window.open(url.href, "_blank");
		},
		// 是否可以继续操作
		isOperate() {
			if (this.userInfo.is_company == 1) {
				this.$alert('企业信息审核中，请在审核通过后再试', '提示', { confirmButtonText: '确定' })
				return false
			}
			return true
		},
		// 去登录
		toLogin() {
			this.$router.push({ name: 'login' })
		},
		// 去注册
		toRegist() {
			this.$router.push({ name: 'regist' })
		},
		// 去个人中心
		toUsercenter() {
			if (this.userInfo && this.userInfo.username) {
				// this.$router.push({name: 'loghome'})
				const url = this.$router.resolve({ name: 'loghome' })
				window.open(url.href, "_blank")
			} else {
				this.$router.push({ name: 'login', params: { name: 'loghome' } })
			}
		},
		// 去首页
		toHome() {
			this.$router.push({ name: 'home' })
		},
		// 点击导航栏--切换搜索类型   1-供应， 2-求购， 3-资讯， 4-展会， 5-企业 6-设计师
		handleClick(tab, event) {
			console.log(tab.name);
			this.keyType = tab.name
		},
		// 输入框下面的按钮
		typeBtnClick(item) {
			// console.log(item.title)
			this.keyWOrds = item.title
		},
		// 退出登录
		logout() {
			this.$store.dispatch('LogOut').then(() => {
				if (this.$route.name === 'home') {
					location.reload()
				} else {
					this.$router.push({ name: 'home' })
				}
			})
		},
		// 搜索
		searchClick() {
			// 关键词为空不不触发搜索
			if (!this.keyWOrds) return this.$message({
				showClose: true,
				message: '关键字不能为空',
				type: 'warning'
			});
			let pathname = ''
			let type = ''
			if (this.keyType == 1) {
				pathname = 'productClass'
				type = 1
			} else if (this.keyType == 2) {
				pathname = 'productPurchase'
			} else if (this.keyType == 3) {
				pathname = 'industryList'
			} else if (this.keyType == 4) {
				pathname = 'exhibitionList'
			} else if (this.keyType == 5) {
				pathname = 'allcompany'
			} else if (this.keyType == 6) {
				pathname = 'designerIndex'
			}
			const url = this.$router.resolve({ name: pathname, query: { keyword: this.keyWOrds, type: type } })
			window.open(url.href, "_blank")
		},
		// 是否可以发布供应信息   1-供应  2-采购
		isAdd(type) {
			let isGo = this.isOperate()
			if (!isGo) return
			let obj = { userid: this.userInfo.id }
			let ajax = supply_search
			if (this.userInfo.vip_type == 2 || this.userInfo.vip_type == 5) {
				ajax = buy_search
			}
			ajax(obj).then(res => {
				if (res.code === 200) {
					let url = this.$router.resolve({ name: 'logsupplyAdd' })
					if (type == 2) url = this.$router.resolve({ name: 'logsupplyAddBuy' })
					window.open(url.href, "_blank");
				} else {
					this.$message({ message: res.msg, type: 'error', duration: 2500 })
				}
			})
		},
		// 设计师是否可以发布作品
		isAddDesigner() {
			if (this.$route.name === 'logdesignerManage') {
				return
			}
			designer_work_search({ userid: this.userInfo.id }).then(res => {
				if (res.code === 200) {
					const url = this.$router.resolve({ name: 'logdesignerManage' });
					window.open(url.href, "_blank");
				} else {
					this.$message({ message: res.msg, type: 'error', duration: 2500 })
				}
			})
		},
		// 图片上传成功
		handleAvatarSuccess(res, file) {
			if (res.code == 200) {
				this.newUrl = this.$router.resolve({ name: 'imgSearchList', query: { url: res.data } })
				this.dialogVisible = true
			} else {
				this.$message({ message: '上传图片出错!', type: 'error', duration: 3000 })
			}
			this.loading = false
		},
		// 图片上传前的验证
		beforeAvatarUpload(file) {
			this.loading = true
			const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
			const isLt4M = file.size / 1024 / 1024 < 4;

			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 格式!');
			}
			if (!isLt4M) {
				this.$message.error('上传头像图片大小不能超过 4MB!');
			}
			return isJPG && isLt4M;
		},
		toNewPage() {
			this.dialogVisible = false
			window.open(this.newUrl.href, "_blank")
		}
	},
	watch: {
		// 监听路由的变化
		$route(val) {
			this.isLogin(getToken())
			this.isUsercenter(val.name.substr(0, 3))
		}
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/index.scss';

.headWrapper,
.headWrapper-userCenter {
	width: 100%;
	padding: 0 80px;
	margin-top: 10px;

	.lineTop {
		width: 100%;
		height: 30px;
		line-height: 30px;

		.lineTopLeft {
			float: left;
			font-size: 12px;

			a {
				margin-left: 20px;
				color: $fontColor;
			}

			.username {
				margin-left: 20px;
				color: $fontColor;
			}

			.logout {
				color: rgba(51, 51, 51, 1);
			}

			.logout:hover {
				color: $fontColor;
			}
		}

		.lineTopRight {
			font-size: 12px;
			float: right;

			a {
				margin-right: 10px;
			}

			a:hover,
			.tel {
				color: $fontColor;
			}
		}
	}

	.lineMiddle {
		position: relative;
		margin-top: 20px;

		.logo {
			.logoImg {
				/*width: 175px;*/
				height: 52px;
			}

			.logoImg:hover {
				cursor: pointer;
			}
		}

		.search {
			position: absolute;
			left: 15%;
			top: 15px;
			width: 60%;
			text-align: center;

			.tab {
				position: absolute;
				top: -20px;
				left: 200px;

				/deep/ .el-tabs__active-bar {
					width: 0;
					height: 0;
					border: 0;
				}

				/deep/ .el-tabs__item {
					width: 34px;
					height: 20px;
					line-height: 20px;
					font-size: 12px;
					padding: 0 5px;
				}

				/deep/ .el-tabs__item.is-active {
					background-color: $fontColor;
					color: #fff;
					text-align: center;
				}
			}

			.search_icon {
				position: absolute;
				left: 215px;
				top: 10px;
				z-index: 999;
			}

			.camera_icon {
				position: absolute;
				right: -115px;
				top: 8px;
				z-index: 999;
			}

			.camera_icon:hover {
				cursor: pointer;
			}

			.searchInput {
				width: 100%;
				margin-left: 200px;
				border: 2px solid $fontColor;

				.searchBtn {
					color: #fff;
					border-radius: 0;
				}
			}

			.typeBtn {
				width: 100%;
				margin-left: 200px;
				margin-top: 5px;
				font-size: 12px;
				text-align: left;

				.typeBtnItem {
					display: inline-block;
					margin-right: 10px;
				}

				.typeBtnItem:hover {
					cursor: pointer;
					color: $fontColor;
				}
			}
		}
	}

	/*非个人中心页面*/
	.nav {
		position: absolute;
		top: 130px;
		left: 0;
		width: 100%;

		.el-menu-demo {
			padding-left: 10%;

			.el-menu-item,
			.el-submenu {
				width: 13%;
				height: 50px;
				line-height: 50px;
				font-size: 16px;
				text-align: center;
				border: 0;
			}

			.el-menu-item:hover,
			.el-submenu:hover {
				background-color: $fontColorHover !important;
			}

			.elMenuTitle {
				padding-top: -10px;
			}
		}

		/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
			height: 50px;
			line-height: 50px;
		}
	}

	/*个人中心页面*/
	.usercenterNav {
		position: absolute;
		top: 40px;
		left: 0;
		width: 100%;

		.logo {
			position: absolute;
			top: 10px;
			left: 1%;
			z-index: 999;

			.logoImg:hover {
				cursor: pointer;
			}
		}

		.el-menu-demo {
			padding-left: 16%;

			.el-menu-item,
			.el-submenu {
				width: 11%;
				height: 62px;
				line-height: 62px;
				font-size: 16px;
				text-align: center;
				border: 0;
			}

			.el-menu-item:hover,
			.el-submenu:hover {
				background-color: $fontColorHover !important;
			}
		}
	}
}

.headWrapper {
	height: 170px;
}

.headWrapper-userCenter {
	height: 100px;
}

/* 导航下拉父元素的背景样式 */
/*.el-menu--horizontal /deep/ .el-submenu .el-submenu__title {
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		border: 0;
	}*/
/* 导航下拉子元素的背景样式 */
.el-menu--horizontal .el-menu .el-menu-item:hover {
	background-color: $fontColorHover !important;
}

/deep/ .el-submenu .el-submenu__title:hover {
	background-color: $fontColorHover !important;
}

/deep/ .el-input-group__append,
.el-input-group__prepend {
	background-color: $fontColor;
	border: 2px solid $fontColor;
	border-radius: 0;
}

/deep/ .el-input__inner {
	border: 0;
	border-radius: 0;
	padding: 0 40px;
}

/deep/ .el-input-group__prepend {
	border-left: 0;
}

/deep/ .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
	border-bottom: 0;
}

.el-menu-item.is-active {
	/*导航栏点击后仍然保持原色*/
	background: rgb(255, 157, 7) !important;
}

/deep/ .search .el-tabs__item {
	width: 44px !important;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
	display: none;
}

/deep/ .el-submenu__title {
	font-size: 16px;
}

@media print {
	.noprint {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/pageHead.vue